import { HttpClientModule, HttpClient, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { User } from './model/user.model';
import { Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AppRoutingModule } from './app-routing.module';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class AppService {
	sharedData: string;
	modalReference: NgbModalRef;
	referralUrl = document.referrer;
	domainReferral = this.referralUrl.split("/").slice(0,3).join("/");
	referURL: string;
	rootURL: string;
	origin = window.location.hostname;
	url = new URL(window.location.href);
	getPrevLang: string;

  	constructor(private http: HttpClient, private router: AppRoutingModule, private modalService: NgbModal, private translateService: TranslateService) {
		this.getJSON().subscribe(data => {
			this.referURL = data.urlReferral;	
			this.rootURL = origin+data.api;
			// this.rootURL = "https://10.0.60.119:8443"+data.api;
		});

		if(this.url.searchParams.get("lang")) {
			this.getPrevLang = this.url.searchParams.get("lang");
			localStorage.setItem('locale', this.getPrevLang);  
    		this.translateService.use(this.getPrevLang); 
			this.translateService.currentLang = this.getPrevLang;
		}
	}

	public hasTranslation(translationKey: string, language?: string): boolean {		
		const translations = this.translateService.translations[language || this.translateService.currentLang];
		return translations && translations["error"][translationKey] !== undefined;
	}

	public getJSON(): Observable<any> {
		return this.http.get("./assets/appsettings.json");
	}

	addMember(formDir:any, form:any, user:User, tok:string, popup): Observable<any> {
		let ok: string;
		const headers = { 
			'content-type': 'application/json', 
			'Authorization': ''
		}
		const body=JSON.stringify(user);

		return this.http.post<User>(this.rootURL+"?g-recaptcha-response="+tok, body, {'headers': headers, observe: 'response', 'responseType': 'json'})
		.pipe(
			map((data) => {
				var getCode;
				var responseCode;
				
				if (data.body) {
					for (getCode in data.body) {
						responseCode = data.body[getCode];						
					}

					// Popup
					if(responseCode !== null || responseCode !== "") {	
						if(responseCode == '0') { // success
							this.modalReference = this.modalService.open(popup[0], { centered: true, size: 'lg' });
				
							if(this.referURL == this.domainReferral) {
								$("#iAkaunPromo").addClass('hide');
							} else {
								$("#iAkaunPromo").removeClass('hide');
							}						
						} else if (responseCode == 'MBM5020' || responseCode == 'MBM5093') { // no record
							this.modalReference = this.modalService.open(popup[1], { centered: true, size: 'lg' });											
						} else if (responseCode == 'MBM5235') {	// registered isaraan					
							this.modalReference = this.modalService.open(popup[2], { centered: true, size: 'lg' }); 
						} else if (responseCode == 'S910') { // auto isuri
							this.modalReference = this.modalService.open(popup[3], { centered: true, size: 'lg' });
							$("#icon_success").show();
						} else if (responseCode == 'MBM7099' || responseCode == 'MBM5223') { // failed
							this.modalReference = this.modalService.open(popup[4], { centered: true, size: 'lg' });
						} else if (responseCode == 'MBM5236') { // registered isuri
							this.modalReference = this.modalService.open(popup[3], { centered: true, size: 'lg' });
							$("#icon_success").hide();
						} else {							
							$('#topAlert').removeClass('hide');
							if (this.hasTranslation(responseCode, this.translateService.currentLang) == true) {	// error declared															
								this.sharedData = responseCode;
								form.setErrors({'ErrorResponse': true});				
								window.scrollTo(500, 0);
								grecaptcha.reset();								
							} else { // error not declared
								this.sharedData = "REG999-"+responseCode;
								form.setErrors({'ErrorResponse': true});
								window.scrollTo(500, 0);
								grecaptcha.reset();								
							}							
						}						
					} 
				} 
				return data;
			}),
			catchError((err) => {		
				$('#topAlert').removeClass('hide');	
				this.sharedData = "REG000";
				form.setErrors({'ErrorResponse': true});
				window.scrollTo(500, 0);
				grecaptcha.reset();
				throw err;
			})
		);	
	}	
}


